module.exports = __webpack_public_path__ + "static/women-fire-and-dangerous-things-8a9aaa8cc47558341d6feba8628a8901.jpg";